import cn from 'classnames';
import { forwardRef } from 'react';

import type { ForwardedRef, ReactElement } from 'react';

import type { TagGroupProps } from './tag-group.types';

import './tag-group.scss';

/**
 * Container component for tags.
 *
 * ### Usage
 *
 * ```tsx
 * import { TagGroup } from '@bloomreach/react-banana-ui';
 *
 * export default function MyCustomComponent() {
 *   return (
 *     <TagGroup>
 *       <InputTag>Banana</InputTag>
 *       <AssetTag variant="accent-2">Apple</AssetTag>
 *       <AssetTag variant="accent-3">Watermelon</AssetTag>
 *     </TagGroup>;
 *   )
 * }
 * ```
 */
const TagGroup = forwardRef((props: TagGroupProps, forwardedRef: ForwardedRef<HTMLDivElement> | null): ReactElement => {
  const {
    children,
    className,
    ...rest // Capture any other properties to pass them to the root element, like `aria-*`, `data-*`, etc.
  } = props;

  return (
    <div {...rest} className={cn('rbui-tag-group', className)} ref={forwardedRef}>
      {children}
    </div>
  );
});

TagGroup.displayName = 'TagGroup';

export default TagGroup;
